import React from 'react';
import {useTranslation} from 'react-i18next';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {validateNameYourPrice} from '../../services/utils/validateNameYourPrice/validateNameYourPrice';
import {useBiLogger} from '../BiProvider/withBiLogger';
import {NameYourPriceForm} from '../NameYourPriceForm/NameYourPriceForm';
import {Price} from '../Price/Price';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import styles from './NameYourPrice.scss';

interface IProps {
  entityType: string;
  minPrice: number;
  maxPrice: number;
  currency: string;
  onContinue: ({price}: {price: number}) => {};
}

export const NameYourPrice: React.FunctionComponent<IProps> = (props) => {
  const {minPrice, maxPrice, currency, entityType} = props;
  const {t} = useTranslation();
  const biLogger = useBiLogger();

  function handleSubmit({price}) {
    const {currency, minPrice, entityType, onContinue} = props;
    biLogger.log(BI_SCHEMA.player.downloadPage.continue.clicked, {
      price: Math.round(Number(price) * 10000),
      errorMsg: '',
      minPrice: Math.round(minPrice * 10000),
      currency,
      isSuccess: true,
      type: entityType,
    });
    onContinue({price: Number(price)});
  }

  function handleValidationFailed({errorMessage, price}) {
    const {minPrice, maxPrice, currency, entityType} = props;

    const errorMsg =
      errorMessage ||
      validateNameYourPrice({
        t,
        minPrice,
        maxPrice,
        currency,
        entityType,
      })({price}).price;

    biLogger.log(BI_SCHEMA.player.downloadPage.continue.clicked, {
      price: price === undefined || price === '' ? undefined : Math.round(Number(price) * 10000),
      errorMsg,
      minPrice: Math.round(minPrice * 10000),
      currency,
      isSuccess: false,
      type: entityType,
    });
  }

  return (
    <div data-hook="nameYourPrice">
      <Subtitle className={styles.nameYourPriceSubtitle}>{t('mgw.nameYourPrice')}</Subtitle>
      <SmallParagraph className={styles.minPriceTip} dataHook="minPriceTip">
        <Price price={minPrice} priceKey="minPrice" currency={currency} translationKey="mgw.nameYourPriceMinTip" />
      </SmallParagraph>
      <NameYourPriceForm
        entityType={entityType}
        minPrice={minPrice}
        maxPrice={maxPrice}
        currency={currency}
        handleSubmit={handleSubmit}
        handleValidationFailed={handleValidationFailed}
      />
    </div>
  );
};
